import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "4"
    }, [
      _createElementVNode("path", { d: "M20 20h160M20 20v160M20 20l160 160M20 100h160M100 20v160M20 20q40 40 80 0M100 20q40 40 80 0M20 60q50 20 80 0 30 20 80 0M20 100q50 30 80 0 30 30 80 0M20 140q50 20 80 0 30 20 80 0" })
    ], -1)
  ]))]))
}
export default { render: render }